import createIcon from '../../createIcon';

/**
 * @component @name Chalet
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS43NSA4TDE3LjI1IDE1LjVMMTUuODQgMTYuOTFMMTQuNzUgMTUuODNWMjAuNUgxMC43NVYxNS41SDguNzVWMjAuNUg0Ljc1VjE1LjgzTDMuNjYgMTYuOTJMMi4yNSAxNS41TDkuNzUgOFpNMjEuNzUgN0gyMC41NkwyMS4zMSA2LjI1TDIwLjYgNS41NEwxOS4xNCA3SDE4LjI1VjYuMTFMMTkuNyA0LjY2TDE4Ljk5IDMuOTVMMTguMjUgNC42OVYzLjVIMTcuMjVWNC42OUwxNi41IDMuOTRMMTUuNzkgNC42NUwxNy4yNCA2LjFWN0gxNi4zNUwxNC45IDUuNTVMMTQuMTkgNi4yNkwxNC45NCA3LjAxSDEzLjc1VjguMDFIMTQuOTRMMTQuMTkgOC43NkwxNC45IDkuNDdMMTYuMzUgOC4wMkgxNy4yNFY4LjkxTDE1Ljc5IDEwLjM2TDE2LjUgMTEuMDdMMTcuMjUgMTAuMzJWMTEuNUgxOC4yNVYxMC4zMUwxOSAxMS4wNkwxOS43MSAxMC4zNUwxOC4yNSA4Ljg5VjhIMTkuMTRMMjAuNTkgOS40NUwyMS4zIDguNzRMMjAuNTYgOEgyMS43NVY3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Chalet = createIcon('Chalet', [
  [
    'path',
    {
      d: 'M9.75 8L17.25 15.5L15.84 16.91L14.75 15.83V20.5H10.75V15.5H8.75V20.5H4.75V15.83L3.66 16.92L2.25 15.5L9.75 8ZM21.75 7H20.56L21.31 6.25L20.6 5.54L19.14 7H18.25V6.11L19.7 4.66L18.99 3.95L18.25 4.69V3.5H17.25V4.69L16.5 3.94L15.79 4.65L17.24 6.1V7H16.35L14.9 5.55L14.19 6.26L14.94 7.01H13.75V8.01H14.94L14.19 8.76L14.9 9.47L16.35 8.02H17.24V8.91L15.79 10.36L16.5 11.07L17.25 10.32V11.5H18.25V10.31L19 11.06L19.71 10.35L18.25 8.89V8H19.14L20.59 9.45L21.3 8.74L20.56 8H21.75V7Z',
      key: 'xn6tj1',
    },
  ],
]);

export default Chalet;
